<determinant-builder-new *ngIf="showBuilder && serviceId"
    [serviceId]="serviceId"
    [showSaveCancelRow]=false
    [jsonString]="jsonString"
    (onSave)="update($event)"
    (onChange)="builderChanged($event)"
    (onCancel)="onCancel()"
    [determinantMapById]="determinantMapById"
    (onAddModalOpened)="openEdit()"
    (onEditModalOpened)="openEditDet($event)"
    class="d-flex overflow-hidden mh-100 h-100  w-100 {{showEdit ? 'd-none' : ''}} flex-column">
</determinant-builder-new>
<determinant-new *ngIf="showEdit && serviceId"
    class="d-flex overflow-hidden mh-100 w-100 flex-column"
    [serviceId]="serviceId"
    [determinant]="selectedDeterminant"
    [isEmbedded]="embedded"
    [isClosed]="false"
    (formSubmit)="closeEdit($event)"
    (editCancel)="closeEdit($event)">
</determinant-new>